export default __webpack_public_path__ + "static/media/pull.8631076f.svg";